import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "plan-buttons hide-desktop" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "",
    class: "btn btn-primary"
  }, " Missing Contributions Form "),
  /*#__PURE__*/_createElementVNode("p", {
    class: "btn btn-secondary plan-modal",
    "data-modal-name": "pension-contribution-history"
  }, " View Details ")
], -1)
const _hoisted_2 = { class: "plan-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_WorkHistoryFilters = _resolveComponent("WorkHistoryFilters")!
  const _component_WorkHistoryListAlternative = _resolveComponent("WorkHistoryListAlternative")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_MessageCard, {
      message: "This page allows you to look for specific employer contributions received on your behalf based on different search parameters.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_WorkHistoryFilters, {
        filters: $setup.filters,
        onUpdateFilters: $setup.updateFilters,
        loading: $setup.loading,
        printing: $setup.printing,
        disabled: !Object.values($setup.workHistoryData.Years)?.length
      }, null, 8, ["filters", "onUpdateFilters", "loading", "printing", "disabled"]),
      _createVNode(_component_WorkHistoryListAlternative, {
        data: $setup.workHistoryData,
        loading: $setup.loading
      }, null, 8, ["data", "loading"])
    ])
  ], 64))
}